<template>
  <!-- 发票信息弹窗 -->
  <van-popup v-model="popShow" round position="bottom" :style="{ height: '100%' }">
    <h2>发票信息</h2>
    <van-radio-group v-model="active">
      <van-cell-group>
        <van-cell title="不开发票" clickable @click="active = 0">
          <template #right-icon>
            <van-radio :name="0" />
          </template>
        </van-cell>
        <van-cell title="开发票" clickable @click="active = 1">
          <template #right-icon>
            <van-radio :name="1" />
          </template>
        </van-cell>
        <van-cell title="开收据" clickable @click="active = 2">
          <template #right-icon>
            <van-radio :name="2" />
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
    <!-- <van-tabs v-model="active">
			<van-tab title="不开发票" :name="1"></van-tab>
			<van-tab title="开发票" :name="2">
				<van-form ref="form" @submit="onSubmit">
					<van-field name="发票类型" label="发票类型">
						<template #input>普通发票</template>
					</van-field>
					<van-field name="发票内容" label="发票内容">
						<template #input>发票明细</template>
					</van-field>
					<van-field name="抬头类型" label="抬头类型">
						<template #input>单位</template>
					</van-field>
					<van-field v-model="formData.fptt" name="fptt" label="发票抬头" placeholder="必填" :rules="[{ required: true, message: '填写需要开具发票的抬头名称' }]" />
					<van-field v-model="formData.sh" name="sh" label="税号" placeholder="必填" :rules="[{ required: true, message: '纳税人识别号' }]" />
					<van-field v-model="formData.khyh" name="khyh" label="开户银行" placeholder="选填" />
					<van-field v-model="formData.yhzh" name="yhzh" label="银行账户" placeholder="选填" />
					<van-field v-model="formData.dwdz" name="dwdz" label="单位地址" placeholder="选填" />
					<van-field v-model="formData.dwdh" name="dwdh" label="单位电话" placeholder="选填" @touchstart.native.stop="numberKeyboardShow = true"> </van-field>
					<van-number-keyboard :show="numberKeyboardShow" @blur="numberKeyboardShow = false" @input="onInput" @delete="onDelete" />
				</van-form>
			</van-tab>
			<van-tab title="开收据" :name="3"></van-tab>
		</van-tabs> -->
    <van-form v-if="active === 1" ref="form" @submit="onSubmit">
      <van-field name="invoicetype" label="发票类型">
        <template #input>普通发票</template>
      </van-field>
      <van-field name="invoicedesc" label="发票内容">
        <template #input>发票明细</template>
      </van-field>
      <van-field name="invoiceheadtype" label="抬头类型">
        <template #input>单位</template>
      </van-field>
      <van-field
        v-model="formData.invoicehead"
        name="invoicehead"
        label="发票抬头"
        placeholder="填写需要开具发票的抬头名称"
        :rules="[{ validator: validateInputRequired, message: '发票抬头名称不能为空' }]"
      />
      <van-field v-model="formData.invoicenumber" name="invoicenumber" label="税号" placeholder="纳税人识别号" :rules="[{ validator: validateInputRequired, message: '纳税人识别号不能为空' }]">
        <template #label>
          <div class="text-justify">税<span>号</span></div>
        </template>
      </van-field>
      <van-field v-model="formData.openbankname" name="openbankname" label="开户银行" placeholder="选填" :rules="[{ validator: validateInputNoRequired }]" />
      <van-field v-model="formData.openbankaccount" name="openbankaccount" label="银行账户" placeholder="选填" :rules="[{ validator: validateInputNoRequired }]" />
      <van-field v-model="formData.unitaddress" name="unitaddress" label="单位地址" placeholder="选填" :rules="[{ validator: validateInputNoRequired }]" />
      <van-field v-model="formData.unitphone" type="digit" name="unitphone" label="单位电话" placeholder="选填" :rules="[{ validator: validateInputNoRequired }]"> </van-field>
      <!-- <van-number-keyboard :show="numberKeyboardShow" @blur="numberKeyboardShow = false" @input="onInput" @delete="onDelete" /> -->
    </van-form>
    <!-- 确认选择 -->
    <van-button type="primary" block @click="ok">确认</van-button>
  </van-popup>
</template>

<script>
  import axios from 'axios'

  export default {
    model: {
      event: 'change',
      prop: 'show'
    },
    props: ['show', 'info'],
    data() {
      return {
        active: 0,
        formData: {
          unitphone: ''
        },
        numberKeyboardShow: false,
        popShow: false,
        source: null
      }
    },
    watch: {
      show(newValue, oldValue) {
        this.popShow = newValue
      }
    },
    methods: {
      /**
       * todo 点击确认按钮
       */
      ok() {
        // 开发票
        if (this.active === 1) {
          this.$refs.form.submit()
          // 开收据
        } else if (this.active === 2) {
          const beforeClose = (action, done) => {
            if (action === 'confirm') {
              this.$emit('change', false)
              this.$emit('confirmInfo', this.active)
            }
            done()
          }

          this.$dialog.confirm({
            message: '收据将与您的报纸一并寄出',
            beforeClose
          })
          // 不开发票
        } else {
          this.$emit('change', false)
          this.$emit('confirmInfo', this.active)
        }
      },
      /**
       * todo 提交验证方法
       */
      onSubmit(values) {
        const beforeClose = (action, done) => {
          if (action === 'confirm') {
            this.$emit('change', false)
            this.$emit('confirmInfo', this.active, values)
          }
          done()
        }

        this.$dialog.confirm({
          message: '开发票时间需要等待20个工作日',
          beforeClose
        })
      },
      /**
       * todo 模拟数字键盘输入
       */
      onInput(value) {
        this.formData.unitphone += value + ''
      },
      onDelete(value) {
        this.formData.unitphone = value
      },
      /**
       * todo 自定义敏感词校验规则 必填
       * @description 带必填校验
       */
      validateInputRequired(value, rule) {
        return this.validateInput(...arguments, 1)
      },
      /**
       * todo 自定义敏感词校验规则 选填
       * @description 无必填校验
       */
      validateInputNoRequired(value, rule) {
        return this.validateInput(...arguments, 0)
      },
      /**
       * todo 自定义敏感词校验规则 主体部分
       * @description 公用逻辑
       */
      validateInput(value, rule, type) {
        if (type && !value) {
          return false
        }
        // if (this.source) {
        //   this.source.cancel('取消查询！')
        // }
        return new Promise((resolve, reject) => {
          let params = {
            contentStr: value
          }
          let cancelToken = axios.CancelToken
          this.source = cancelToken.source()
          this.$api.userComplaints.checkSensitiveWords(params, { cancelToken: this.source.token }).then((res) => {
            let { count, result } = res
            if (count > 0) {
              resolve(true)
            } else {
              rule.message = result
              resolve(false, rule)
            }
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .van-popup {
    background: #eee;
    /deep/ .van-field__label {
      color: #000;
    }
    .van-button,
    .van-form {
      margin-top: 1vh;
    }
    .van-button {
      width: 90%;
      margin: 1vh auto;
      height: auto;
      line-height: 2.5;
    }
    .text-justify {
      span {
        margin-left: 1.7rem;
      }
    }
  }
</style>
